import { render, staticRenderFns } from "./EventDetailsInvitations.vue?vue&type=template&id=f2a70f24&scoped=true&"
import script from "./EventDetailsInvitations.vue?vue&type=script&lang=js&"
export * from "./EventDetailsInvitations.vue?vue&type=script&lang=js&"
import style0 from "./EventDetailsInvitations.vue?vue&type=style&index=0&id=f2a70f24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a70f24",
  null
  
)

export default component.exports